// extracted by mini-css-extract-plugin
export default {"container":"IQ-z","topReviewHeading":"JQ-z","criticalReview":"KQ-z","favorableReview":"LQ-z","vsSeparator":"MQ-z"};